import {
    createContext,
    useContext,
    useEffect,
    useState
} from "react";

import axios from "axios";

import { BASE_URL } from "./services/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

    const [token, setToken] = useState(
        sessionStorage.getItem("token") || null
    );

    const [user, setUser] = useState(null);

    const [loading, setLoading] = useState(true);

    useEffect(() => {

        const fetchUser = async () => {

            if (!token) {
                setLoading(false);
                return;
            }

            try {

                const response = await axios.get(
                    `${BASE_URL}/auth/me`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                setUser(response.data);

            } catch (error) {

                logout();
            }

            setLoading(false);
        };

        fetchUser();

    }, [token]);

    const login = (jwtToken) => {

        sessionStorage.setItem("token", jwtToken);

        setToken(jwtToken);
    };

    const logout = () => {

        sessionStorage.removeItem("token");

        setToken(null);

        setUser(null);
    };

    return (
        <AuthContext.Provider
            value={{
                token,
                user,
                loading,
                login,
                logout
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);